import * as React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { Loader } from '@progress/kendo-react-indicators';
import { withRouter } from '../../../components/withRouter';
import { scanQrToken } from '../actions/qr-landing-page-actions';

class QrLandingPage extends React.PureComponent {

  async componentDidMount() {
    const token = this.props.params?.token;
    if (token) {
      await this.props.scanQrToken({ token });
    }
  }

  render() {
    const localizationService = provideLocalizationService(this);
    const { loading, result, errorMessage } = this.props;

    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <div style={{ textAlign: 'center', maxWidth: 400, padding: 24 }}>
          {loading && (
            <>
              <Loader size='large' />
              <p>{localizationService.toLanguageString('qrLanding.processing')}</p>
            </>
          )}
          {!loading && result && !result.alreadyRegistered && (
            <div>
              <h2>{localizationService.toLanguageString('qrLanding.successTitle')}</h2>
              <p>{localizationService.toLanguageString('qrLanding.successMessage')}</p>
            </div>
          )}
          {!loading && result && result.alreadyRegistered && (
            <div>
              <h2>{localizationService.toLanguageString('qrLanding.alreadyRegisteredTitle')}</h2>
              <p>{localizationService.toLanguageString('qrLanding.alreadyRegisteredMessage')}</p>
            </div>
          )}
          {!loading && errorMessage && (
            <div>
              <h2>{localizationService.toLanguageString('qrLanding.errorTitle')}</h2>
              <p>{errorMessage}</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.qrLandingPage.loading,
  result: state.qrLandingPage.result,
  errorMessage: state.qrLandingPage.errorMessage
});

const mapDispatchToProps = (dispatch) => ({
  scanQrToken: (payload) => dispatch(scanQrToken(payload))
});

registerForLocalization(QrLandingPage);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QrLandingPage));
